import { useInstructionsScript } from 'hooks/useInstructionsScript';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import './QRInstructions.scss';
import {
  HTTPStatuses,
  PAYMENT_STATUS_CANCELLED,
  PAYMENT_STATUS_FAILED,
  PAYMENT_STATUS_PENDING,
} from 'constants/index';
import { EmbeddedRepository } from 'repositories/embedded/embedded';
import { RedirectUrl } from 'utils';
import { payex } from '../../../services/payex';

const INTERVAL_MS = 5000;
function redirectToExternalUrl({ url, id, status }) {
  const returnUrlWithId = RedirectUrl.build(url, id, status);
  const onFinish = EmbeddedRepository.getProp('fwFinish');

  onFinish(returnUrlWithId.toString());
}

async function pollPaymentStatus(paymentId: string, returnUrl: string) {
  const response = await payex.polling.pollPaymentStatus(paymentId);
  const status = response.status;

  if (status === PAYMENT_STATUS_PENDING || status === HTTPStatuses.NOT_FOUND) {
    return setTimeout(
      () => pollPaymentStatus(paymentId, returnUrl),
      INTERVAL_MS,
    );
  }

  const redirectStatus = [
    PAYMENT_STATUS_FAILED,
    PAYMENT_STATUS_CANCELLED,
  ].includes(status)
    ? 'error'
    : 'success';

  redirectToExternalUrl({
    id: paymentId,
    url: returnUrl,
    status: redirectStatus,
  });
}

function QRInstructions({
  embeddedScript,
  i18n,
  locale,
  publicKey,
  scriptSignature,
  paymentId,
  returnUrl,
}) {
  useInstructionsScript({ embeddedScript, publicKey, scriptSignature });

  useEffect(() => {
    setTimeout(() => pollPaymentStatus(paymentId, returnUrl), INTERVAL_MS);
  }, [paymentId, returnUrl]);

  return (
    <div
      data-testid="onlineInstructions"
      id="payment"
      className="EmbeddedScript EmbeddedScript--QR"
      data-locale={locale}
    >
      <h3>{i18n.t('online.qr.title')}</h3>
      <p>{i18n.t('online.qr.description')}</p>
    </div>
  );
}

QRInstructions.propTypes = {
  embeddedScript: PropTypes.object,
  i18n: PropTypes.shape({ t: PropTypes.func.isRequired }),
  locale: PropTypes.string,
  paymentId: PropTypes.string,
  publicKey: PropTypes.string,
  returnUrl: PropTypes.string,
  scriptSignature: PropTypes.object,
};

export { QRInstructions };
